import script from "./tableText.vue?vue&type=script&lang=ts&setup=true"
export * from "./tableText.vue?vue&type=script&lang=ts&setup=true"

import "./tableText.vue?vue&type=style&index=0&id=baefc420&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baefc420"]])

export default __exports__